import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { getImpactStoryDetails } from "../../action/impact-story";
import { fetchAllLanguages } from "../../action/language";

const ImpactStoryDetails = () => {
  const { id } = useParams();
  const location = useLocation();

  const [story, setStory] = useState(null);
  const [languages, setLanguages] = useState([]);
  const [activeLang, setActiveLang] = useState("en");
  const [langList, setLangList] = useState([]);

  const fetchLangs = async () => {
    try {
      const res = await fetchAllLanguages();
      if (res.status) {
        setLangList(res.data);
      }
    } catch(error) {
      console.log("failed to fetch languages", error);
    }
  };

  useEffect(() => {
    fetchLangs();
    fetchDetails();
  }, [id]);

  const fetchDetails = async () => {
    const res = await getImpactStoryDetails(id);
    if (!res?.status) return;

    const data = res.data;

    // 🔑 extract languages that exist in BOTH title & desc
    const langs = Array.from(
      new Set(
        data.assets.flatMap((a) => {
          const titleLangs = Object.keys(a.title || {});
          const descLangs = Object.keys(a.desc || {});
          return titleLangs.filter((l) => descLangs.includes(l));
        })
      )
    );

    setStory(data);
    setLanguages(langs.length ? langs : ["en"]);
    setActiveLang(langs[0] || "en");
  };

  const getLanguageName = (code) =>
    langList.find((l) => l.shortCode === code)?.name || code.toUpperCase();

    if (!story) return null;

  return (
    <div className="pagecolwrap">
      {/* HEADER */}
      <div className="payout_data-head">
        <Breadcrumb
          paths={[
            {
              name: "Impact Stories",
              link: "/impact-story",
              state: location.state,
            },
            { name: "Impact Story Details", link: `/impact-story/${id}` },
          ]}
        />
      </div>

      <div className="row">
        {/* LEFT */}
        <div className="col-md-8">
          {story.assets.map((asset, index) => (
            <div key={index} className="payout_data-content mb-3">
              <div className="row">
                <div className="col-md-4">
                  <label className="input-label">Image</label>
                  <img
                    src={process.env.REACT_APP_S3_URL + `/${asset.url}`}
                    alt=""
                    style={{
                      width: "100%",
                      height: "250px",
                      objectFit: "cover",
                    }}
                  />
                </div>

                <div className="col-md-8">
                  <div className="input-box mt-0">
                    <label className="input-label">
                      Title ({getLanguageName(activeLang)})
                    </label>
                    <div className="input_field view-text">
                      {asset.title?.[activeLang] || "-"}
                    </div>
                  </div>

                  <div className="input-box">
                    <label className="input-label">
                      Caption ({getLanguageName(activeLang)})
                    </label>
                    <div className="input_field view-text">
                      {asset.desc?.[activeLang] || "-"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* RIGHT */}
        <div className="col-md-4">
          <div className="payout_data-content mb-3">
            <h4>General Details</h4>
            <div className="input-box mt-0">
              <label className="input-label">Redirect URL</label>
              <div className="input_field view-text">
                {story.extras?.url || ""}
              </div>
            </div>
          </div>

          <div className="payout_data-content mb-3">
            <h4>SEO</h4>

            <div className="input-box mt-0">
              <label className="input-label">Focus Keywords</label>
              <div className="input_field view-text">
                {story.extras?.seo?.focus_keywords || "-"}
              </div>
            </div>

            <div className="input-box">
              <label className="input-label">SEO Title</label>
              <div className="input_field view-text">
                {story.extras?.seo?.seoTitle || "-"}
              </div>
            </div>

            <div className="input-box">
              <label className="input-label">SEO Description</label>
              <div className="input_field view-text">
                {story.extras?.seo?.seoDesc || "-"}
              </div>
            </div>
          </div>

          {/* LANGUAGES */}
          <div className="payout_data-content mb-3">
            <h4>Region Specific Content</h4>

            <div className="langbx">
              {languages.map((lang) => (
                <div
                  key={lang}
                  className={`langbx-item ${
                    activeLang === lang ? "active" : ""
                  }`}
                  onClick={() => setActiveLang(lang)}
                >
                  {lang.toUpperCase()}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpactStoryDetails;
